module.exports = __webpack_public_path__ + "banquet/components/images/pro_badge.88877066514495dbecfcd62668d44e8d.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/images/pro_badge.png
// module id = 1039
// module chunks = 1